import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import MyOrder from "@/pages/MyOrder.vue";
import Orders from "@/pages/Orders.vue";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register.vue";
import Users from "@/pages/Users.vue";
import Company from "@/pages/Company.vue"
import Typography from "@/pages/Typography.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";
import Invite from "@/pages/Invite.vue";
import Drawing from "@/pages/Drawing.vue";
import DrawingList from "@/pages/DrawingList.vue";
import SystemLog from "@/pages/SystemLog.vue";
import Lc from "@/pages/Lc.vue";
import Companys from "@/pages/Companys.vue";
import CompanyOrders from "@/pages/CompanyOrders.vue";
const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "user",
    children: [
      {
        path: "user",
        name: "用户信息",
        component: UserProfile,
		meta: { requiresAuth: true }
      },
	  {
	    path: "invite",
	    name: "邀请注册",
	    component: Invite,
		meta: { requiresAuth: true }
	  },
      {
        path: "myorder",
        name: "我的订单",
        component: MyOrder,
		meta: { requiresAuth: true }
      },
	  {
	    path: "orders",
	    name: "订单管理",
	    component: Orders,
		meta: { requiresAuth: true }
	  },
      {
        path: "drawing",
        name: "公开图纸管理",
        component: Drawing,
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
      },
	 {
	   path: "typography",
	   name: "Typography",
	   component: Typography,
	 },
	 {
	   path: "upgradeToPro",
	   name: "Upgrade to PRO",
	   component: UpgradeToPRO,
	 },
      {
        path: "icons",
        name: "Icons",
        component: Icons,
      },
	  {
	    path: "company",
	    name: "客户管理",
	    component:Company,
		meta: { requiresAuth: true }
	  },
      // {
      //   path: "maps",
      //   name: "Maps",
      //   component: Maps,
      // },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
		meta: { requiresAuth: true }
      },      
	  {
	    path: "users",
	    name: "用户管理",
	    component: Users,
		meta: { requiresAuth: true }
	  },
	  {
	    path: "logs",
	    name: "日志",
	    component: SystemLog,
		meta: { requiresAuth: true }
	  },
	  {
	    path: "companys",
	    name: "公司客户管理",
	    component: Companys,
		meta: { requiresAuth: true }
	  },
	  {
	    path: "companyOrders",
	    name: "公司订单管理",
	    component: CompanyOrders,
		meta: { requiresAuth: true }
	  },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
	path: "/register",
	name: "Register",
	component: Register,
  },
  {
	path:"/drawingList",
	name:"DrawingList",
	component:DrawingList,
  },
  {
  	path:"/lc",
  	name:"Lc",
  	component:Lc,
  }
];

export default routes;
